import { io } from 'socket.io-client';
import { WEBSOCKET_EVENTS } from '../consts/enums';

export default defineNuxtPlugin(() => {
  // Internal socket instance (singleton)
  let socket = null;

  /**
   * Connects to the backend WebSocket server
   * Uses runtime config for base URL
   * Accepts optional socket.io options and an onConnect callback
   */
  const connect = (onConnect, options = {}) => {
    if (!socket) {
      const config = useRuntimeConfig();

      socket = io(config.public.websocketBaseUrl, {
        withCredentials: true, // Send cookies if needed
        autoConnect: true, // Auto-connect immediately
        ...options, // Allow override
      });

      // Handle on connect callback
      if (onConnect) {
        socket.on('connect', onConnect);
      }
    }

    return socket;
  };

  /**
   * Cleanly disconnects and clears socket reference
   */
  const disconnect = () => {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  };

  /**
   * Sends a "JOIN" event with room name to backend
   */
  const joinRoom = (room) => {
    if (!socket) return;
    socket.emit(WEBSOCKET_EVENTS.JOIN_ROOM, { room });
  };

  /**
   * Sends a "LEAVE" event with room name to backend
   */
  const leaveRoom = (room) => {
    if (!socket) return;
    socket.emit(WEBSOCKET_EVENTS.LEAVE_ROOM, { room });
  };

  /**
   * Subscribes to a socket event
   */
  const on = (event, callback) => {
    if (!socket) return;
    socket.on(event, callback);
  };

  /**
   * Unsubscribes from a socket event
   * If callback is given, remove only that listener
   * If no callback, remove all listeners for that event
   */
  const off = (event, callback) => {
    if (!socket) return;
    if (callback) socket.off(event, callback);
    else socket.removeAllListeners(event);
  };

  // Provide $ws globally to the app
  return {
    provide: {
      ws: {
        connect,
        disconnect,
        joinRoom,
        leaveRoom,
        on,
        off,
      },
    },
  };
});
